module.exports = __webpack_public_path__ + "static/media/creatives-review.f194e0a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/creatives-review.svg
// module id = 1125
// module chunks = 1